import { User } from "./interfaces";

const LIFT_GROUPS = [
  "FulfillmentToolsDev",
  "Fulfillment Tools Partners",
  "LuceoFulfillmentToolAccess"
];

const TANK_GROUPS = [
  "FulfillmentToolsDev",
  "Fulfillment Tools Partners",
  "TANKFulfillmentToolAccess",
  "TANKFulfillmentToolReadOnly"
];

export function getAccessibleApps(user: User): string[] {
  if (!user || user.idp !== "saml") return [];

  const apps = [];

  for (const group of LIFT_GROUPS) {
    if (user.appendix.groups.includes(group)) {
      apps.push("lift");
      break;
    }
  }

  for (const group of TANK_GROUPS) {
    if (user.appendix.groups.includes(group)) {
      apps.push("tank");
      apps.push("talent-network");
      apps.push("company-page");
      apps.push("account");
      break;
    }
  }

  return apps;
}

export function hasAppAccess(user: User, app: string): boolean {
  return getAccessibleApps(user).includes(app.toLowerCase());
}

export function hasNoAppAccess(user: User): boolean {
  return getAccessibleApps(user).length === 0;
}



// WEBPACK FOOTER //
// ./src/common/app-access.ts